import { DeleteOutlined } from "@ant-design/icons";
import { Button, Form, Table, Popconfirm, message } from "antd";
import React, { useState } from "react";
import DbConnectionModal from "./DbConnectionModal";

function DbConnectionsView(props) {
  const [dataSource, setDataSource] = useState(props.initialData);
  const [newRows, setNewRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const columns = [
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: "4%",
      render: (_, record) => (
        <Popconfirm
          title={`Are you sure you want to delete ${record.displayName}?`}
          onConfirm={() => handleDelete(record.displayName)}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
    {
      title: "Display Name",
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: "Database Type",
      dataIndex: "databaseType",
      key: "databaseType",
    },
    {
      title: "Host Name",
      dataIndex: "hostName",
      key: "hostName",
    },
    {
      title: "Port",
      dataIndex: "port",
      key: "port",
    },
    {
      title: "Database Name",
      dataIndex: "dbName",
      key: "dbName",
    },
  ];
  const handleDelete = (displayName) => {
    const newData = dataSource.filter(
      (item) => item.displayName !== displayName,
    );
    const newUpdatedData = newRows.filter(
      (item) => item.displayName !== displayName,
    );
    setDataSource(newData);
    setNewRows(newUpdatedData);
    props.updateDbDataSource(newUpdatedData, displayName);
  };

  const onAddClick = () => {
    setIsModalOpen(!isModalOpen);
  };
  const onModalClose = () => {
    setIsModalOpen(false);
  };

  const updateTable = (formData) => {
    const displayNameExists = dataSource.some(
      (item) => item.displayName === formData.displayName,
    );
    if (displayNameExists) {
      message.error("A record with this Display Name already exists.");
      return;
    }
    const updatedData = [...dataSource, { key: Date.now(), ...formData }];
    const newUpdateData = [...newRows, { key: Date.now(), ...formData }];
    setDataSource(updatedData);
    setNewRows(newUpdateData);
    props.updateDbDataSource(newUpdateData);
    setIsModalOpen(false);
  };

  return (
    <div>
      <Form form={form} component={false}>
        <Table
          dataSource={dataSource}
          columns={columns}
          rowClassName="editable-row"
          pagination={false}
        />
      </Form>
      <Button
        onClick={onAddClick}
        type="primary"
        style={{ marginBottom: 16, marginTop: 16 }}
      >
        Add Connection
      </Button>
      <DbConnectionModal
        isOpen={isModalOpen}
        onCancel={onModalClose}
        updateTable={updateTable}
      />
    </div>
  );
}

export default DbConnectionsView;
